/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface CoreSlice {
  accountDrawerOpen: boolean,
  addInvoiceItemDialogOpen: boolean,
  addOrganizationDialogOpen: boolean,
  createClientDialogOpen: boolean,
  createInvoiceDialogOpen: boolean,
  createStaffDialogOpen: boolean,
  createTruckDialogOpen: boolean,
  filterJobListDialogOpen: boolean,
  menuDrawerOpen: boolean,
  title: string,
  updateClientDialogOpen: boolean,
  updateContactDialogOpen: boolean,
  updateInvoiceDialogOpen: boolean,
  updateOrganizationDialogOpen: boolean,
  updateStaffDialogOpen: boolean,
  organizationId: string
}

/**
 * Core Reducer Specs
 */
export const coreSlice = createSlice({
  name: 'core',
  initialState: {
    accountDrawerOpen: false,
    addInvoiceItemDialogOpen: false,
    addOrganizationDialogOpen: false,
    createClientDialogOpen: false,
    createInvoiceDialogOpen: false,
    createStaffDialogOpen: false,
    createTruckDialogOpen: false,
    filterJobListDialogOpen: false,
    invoiceDetailsDialogOpen: false,
    menuDrawerOpen: false,
    title: '',
    updateClientDialogOpen: false,
    updateContactDialogOpen: false,
    updateInvoiceDialogOpen: false,
    updateOrganizationDialogOpen: false,
    updateStaffDialogOpen: false,
    organizationId: 'ORG000001',
  },
  reducers: {
    openAccountDrawer: (state) => { state.accountDrawerOpen = true; },
    openAddInvoiceItemDialog: (state) => { state.addInvoiceItemDialogOpen = true; },
    openAddOrganizationDialog: (state) => { state.addOrganizationDialogOpen = true; },
    openCreateClientDialog: (state) => { state.createClientDialogOpen = true; },
    openCreateInvoiceDialog: (state) => { state.createInvoiceDialogOpen = true; },
    openCreateStaffDialog: (state) => { state.createStaffDialogOpen = true; },
    openFilterJobListDialog: (state) => { state.filterJobListDialogOpen = true; },
    openInvoiceDetailsDialog: (state) => { state.invoiceDetailsDialogOpen = true; },
    openMenuDrawer: (state) => { state.menuDrawerOpen = true; },
    openUpdateContactDialog: (state) => { state.updateContactDialogOpen = true; },
    openUpdateInvoiceDialog: (state) => { state.updateInvoiceDialogOpen = true; },
    openUpdateOrganizationDialog: (state) => { state.updateOrganizationDialogOpen = true; },
    openUpdateStaffDialog: (state) => { state.updateStaffDialogOpen = true; },
    closeAccountDrawer: (state) => { state.accountDrawerOpen = false; },
    closeAddInvoiceItemDialog: (state) => { state.addInvoiceItemDialogOpen = false; },
    closeAddOrganizationDialog: (state) => { state.addOrganizationDialogOpen = false; },
    closeCreateClientDialog: (state) => { state.createClientDialogOpen = false; },
    closeCreateInvoiceDialog: (state) => { state.createInvoiceDialogOpen = false; },
    closeCreateStaffDialog: (state) => { state.createStaffDialogOpen = false; },
    closeCreateTruckDialog: (state) => { state.createTruckDialogOpen = false; },
    closeFilterJobListDialog: (state) => { state.filterJobListDialogOpen = false; },
    closeInvoiceDetailsDialog: (state) => { state.invoiceDetailsDialogOpen = false; },
    closeMenuDrawer: (state) => { state.menuDrawerOpen = false; },
    closeUpdateClientDialog: (state) => { state.updateClientDialogOpen = false; },
    closeUpdateContactDialog: (state) => { state.updateContactDialogOpen = false; },
    closeUpdateInvoiceDialog: (state) => { state.updateInvoiceDialogOpen = false; },
    closeUpdateOrganizationDialog: (state) => { state.updateOrganizationDialogOpen = false; },
    closeUpdateStaffDialog: (state) => { state.updateStaffDialogOpen = false; },
    openCreateTruckDialog: (state) => { state.createTruckDialogOpen = true; },
    openUpdateClientDialog: (state) => { state.updateClientDialogOpen = true; },
    setTitle: (state, action: PayloadAction<string>) => { state.title = action.payload; },
    setOrganizationId: (state, action: PayloadAction<string>) => { state.organizationId = action.payload; },
  },
});

export const {
  openAccountDrawer,
  openAddInvoiceItemDialog,
  openAddOrganizationDialog,
  openCreateClientDialog,
  openCreateInvoiceDialog,
  openCreateStaffDialog,
  openCreateTruckDialog,
  openFilterJobListDialog,
  openInvoiceDetailsDialog,
  openMenuDrawer,
  openUpdateClientDialog,
  openUpdateContactDialog,
  openUpdateInvoiceDialog,
  openUpdateOrganizationDialog,
  openUpdateStaffDialog,
  closeAccountDrawer,
  closeAddInvoiceItemDialog,
  closeAddOrganizationDialog,
  closeCreateClientDialog,
  closeCreateInvoiceDialog,
  closeCreateStaffDialog,
  closeCreateTruckDialog,
  closeFilterJobListDialog,
  closeInvoiceDetailsDialog,
  closeMenuDrawer,
  closeUpdateClientDialog,
  closeUpdateContactDialog,
  closeUpdateInvoiceDialog,
  closeUpdateOrganizationDialog,
  closeUpdateStaffDialog,
  setTitle,
  setOrganizationId,
} = coreSlice.actions;

export default coreSlice.reducer;
